import React from 'react';
import PropTypes from 'prop-types';
import Cards from './Cards.jsx';
import options from '../data/options.json';
import unpackCourses from '../functions/unpackCourses';

const CourseList = (props) => {
    unpackCourses(props.courses, window.mainCategories, props.schools);

    return (
        <Cards courses={props.courses} prices={options.courses.price} lang={props.lang} standalone={true} limit={props.limit} total={props.courses.length} />
    );
};

CourseList.propTypes = {
    courses: PropTypes.array,
    schools: PropTypes.array,
    lang: PropTypes.string,
    limit: PropTypes.number
};

export default CourseList;
